import { render } from "./AlterWallFloorsView.vue?vue&type=template&id=5a4f1e72&scoped=true"
import script from "./AlterWallFloorsView.vue?vue&type=script&lang=js"
export * from "./AlterWallFloorsView.vue?vue&type=script&lang=js"

import "./AlterWallFloorsView.vue?vue&type=style&index=0&id=5a4f1e72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4f1e72"]])

export default __exports__